import React from 'react';
import { Link } from 'react-router-dom';

const AboutPageHero = () => {
  return (
    <>
      <section
        className='about-header-section ptb-120 position-relative overflow-hidden bg-dark'
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat center right",
        }}
      >
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='section-heading-wrap d-flex justify-content-between z-5 position-relative'>
                <div className='about-content-left'>
                  <div className='about-info mb-5'>
                    <h1 className='fw-bold display-5'>
                      Grow your Business with Sunlex payment solutions
                    </h1>
                    <p className='lead'>
                      Founded in 2024, Sunlex emerged to support merchants struggling to keep pace with an increasingly complex payments landscape. Payment gateways, local payment methods, and fraud-risk strategies were often under-optimized for their target markets — leaving businesses with unnecessary friction and missed revenue.
                    </p>
                    <p className='lead'>
                      Sunlex Ltd is duly authorised electronic money institution subject to the prudential supervision of the EU Financial Conduct Authority (Company No. 204749821).
                    </p>
                    <Link to='/contact-us' className='btn btn-primary mt-4 me-3'>
                      Talk to our team
                    </Link>
                  </div>
                  <img
                    src='assets/img/about-img-1.jpg'
                    alt='about'
                    className='img-fluid about-img-first mt-5 rounded-custom shadow'
                  />
                </div>
                <div className='about-content-right'>
                  <img
                    src='assets/img/about-img-2.jpg'
                    alt='about'
                    className='img-fluid mb-5 rounded-custom shadow'
                  />
                  <img
                    src='assets/img/about-img-3.jpg'
                    alt='about'
                    className='rounded-custom about-img-last shadow'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='bg-white position-absolute bottom-0 h-25 bottom-0 left-0 right-0 z-2 py-5'></div>
      </section>
    </>
  );
};

export default AboutPageHero;
